module.exports = __webpack_public_path__ + "img/sukar_no.2834753b.png";